module.exports = __webpack_public_path__ + "static/media/diamondDisabled.3fc89dca.svg";